import { LoadingButton } from '@mui/lab'
import React from 'react'

const LoadingBtn = () => {
    return (
        <LoadingButton loading variant="contained">
            Submit
        </LoadingButton>
    )
}

export default LoadingBtn